import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
import Login from '@/components/Login';
import Carousal from '@/components/carousal';
import ContactGrid from '@/components/contact-grid';
import Tabs from '@/components/tabs';
import Cards from '@/components/cards';
import Loadingspinner from '@/components/loading-spinner';
import Modals from '@/components/modals';
import TooltipAndPopover from '@/components/tooltipandpopover';
import ColorChart from '@/components/colorchart';
import Typography from '@/components/typography';
import Tables from '@/components/tables';
import TablesSelect from '@/components/tablesSelect';
import SupportTicket from '@/components/support-ticket';
import ContactAndEmployee from '@/components/contactandemployee';
import Timeline from '@/components/timeline';
import SweetAlert from '@/components/sweetalert';
import Forms from '@/components/forms';
import Profile from '@/components/profile';
import Buttons from '@/components/buttons';
import Notifications from '@/components/notifications';
import ChatApp from '@/components/chat-app';
import Dragable from '@/components/Dragable';
import ListGroup from '@/components/ListGroup';
import Calendar from '@/components/calendar';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'HelloWorld',
            component: HelloWorld
        },

        {
            path: '/login',
            name: 'Login',
            component: Login
        },

        {
            path: '/carousal',
            name: 'Carousal',
            component: Carousal
        },

        {
            path: '/contact-grid',
            name: 'ContactGrid',
            component: ContactGrid
        },

        {
            path: '/tabs',
            name: 'Tabs',
            component: Tabs
        },

        {
            path: '/cards',
            name: 'Cards',
            component: Cards
        },

        {
            path: '/loading-spinner',
            name: 'Loadingspinner',
            component: Loadingspinner
        },

        {
            path: '/modals',
            name: 'Modals',
            component: Modals
        },

        {
            path: '/tooltipandpopover',
            name: 'TooltipAndPopover',
            component: TooltipAndPopover
        },

        {
            path: '/colorchart',
            name: 'ColorChart',
            component: ColorChart
        },

        {
            path: '/typography',
            name: 'Typography',
            component: Typography
        },

        {
            path: '/tables',
            name: 'Tables',
            component: Tables
        },
        
        {
            path: '/tables_select',
            name: 'TablesSelect',
            component: TablesSelect
        },

        {
            path: '/list_group',
            name: 'ListGroup',
            component: ListGroup
        },

        {
            path: '/support-ticket',
            name: 'SupportTicket',
            component: SupportTicket
        },

        {
            path: '/contactandemployee',
            name: 'ContactAndEmployee',
            component: ContactAndEmployee
        },

        {
            path: '/timeline',
            name: 'Timeline',
            component: Timeline
        },

        {
            path: '/sweetalert',
            name: 'SweetAlert',
            component: SweetAlert
        },

        {
            path: '/forms',
            name: 'Forms',
            component: Forms
        },

        {
            path: '/profile',
            name: 'Profile',
            component: Profile
        },

        {
            path: '/buttons',
            name: 'Buttons',
            component: Buttons
        },

        {
            path: '/notifications',
            name: 'Notifications',
            component: Notifications
        },

        {
            path: '/chat-app',
            name: 'ChatApp',
            component: ChatApp
        },
        
        {
            path: '/dragable',
            name: 'Dragable',
            component: Dragable
        },

        {
            path: '/calendar',
            name: 'Calendar',
            component: Calendar
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js